import AppLayout from '@/layout/AppLayout.vue'

const ChannelVerify = () => import('@/view/channelVerify/ChannelVerify.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/channelVerify',
        component: ChannelVerify,
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
